import { Link } from "react-router-dom";
import founderPic from "../assets/images/profile/Tebogo_Kole-pic-2.jpeg";
import '../styles/FounderInfo.css';

const expertise = ["Regulatory compliance", "Supply chain", "Medical device consulting"];

const FounderInfo = () => { 
    return (
        <section className="km-section km-section--brand founderContainer" id="founder">
            <div className="km-container founder-grid">
                <img src={founderPic} alt="Tebogo Kole, founder of Kole Medical" className="founderPic" data-reveal />
                <div data-reveal style={{ "--reveal-order": 1 } as React.CSSProperties}>
                    <p className="km-eyebrow">Meet our founder</p>
                    <h2 className="km-title">Tebogo Kole</h2>
                    <p className="founderSubtitle">Founder · 10+ years of experience in the medical device industry</p>
                    <p className="founderInfo">
                        Has worked with major companies such as <span>Johnson &amp; Johnson Medical</span>,{" "}
                        <span>Stryker South Africa</span>, <span>Surgicare Medical</span> and many more.
                    </p>
                    <p className="founderExpertLabel">Expert in</p>
                    <ul className="founderExpertise">
                        {expertise.map((item) => <li key={item}>{item}</li>)}
                    </ul>
                    <Link className="km-btn km-btn--outlineLight" to="/events">Join one of Tebogo's webinars</Link>
                </div>
            </div>
        </section>
    );
};


export default FounderInfo;
